class VirtualLicencePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'virtual_licence.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'virtual_licence._m';

    // Access suspended VLs
    static ACCESS_SUSPENDED = 'virtual_licence.access.suspended';

    // Access ended VLs
    static ACCESS_ENDED = 'virtual_licence.access.ended';

    // Allocate new VL
    static CREATE = 'virtual_licence.create';

    // Update VL
    static UPDATE = 'virtual_licence.update';

    // Suspend / Reactivate VL
    static SUSPEND_MANAGE = 'virtual_licence.suspend.manage';

    // Forcibly end VL
    static END = 'virtual_licence.end';

    // Manage VL attachments
    static ATTACHMENT_MANAGE = 'virtual_licence.attachment.manage';
}

export default VirtualLicencePermission;
